<template>
  <div>
    <v-sheet
      class="pa-1"
      color="rounded-tl-xl grey lighten-3"
      elevation="6"
    >
      <v-row>
        <v-col
          cols="12"
          md="12"
        >
          <div
            class="pa-1 text-center blue-grey darken-1 state-title"
          >
            <div class="subtitle-1 white--text">
              {{ tankCurretStatus.targetDeviceTargetDescription }}
            </div>
            <div class="subtitle-1 white--text">
              <router-link
                v-if="tankCurretStatus.targetDeviceId"
                style="color: white"
                :to="{ name: 'tankview', params: { id: tankCurretStatus.targetDeviceId }}"
              >
                {{ tankCurretStatus.targetDeviceDescription }}
              </router-link>
            </div>
          </div>
          <h3 class="blue--text">
            <v-icon class="icon-color">
              mdi-clock
            </v-icon>
            {{ tankCurretStatus.registerAt | formatLongDate }}
          </h3>
        </v-col>
      </v-row>
      <v-row
        dense
        justify="center"
      >
        <v-col
          cols="12"
          md="12"
        >
          <h3 class="current--text">
            {{ $t('tanks-set.current') }}
          </h3>
          <v-card
            class="ma-0 bg-card-content-current"
            height="100"
          >
            <v-card-title class="title-card" />
            <v-card-text>
              <v-col class="content-card">
                <span class="headline-letter">G:</span> <span class="headline white-text">{{ tankCurretStatus.currentGallons }}</span>
              </v-col>
              <v-col class="content-card">
                <span class="headline-letter">L:</span> <span class="headline white-text">{{ tankCurretStatus.currentLiters }}</span>
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="12"
        >
          <h3 class="minimun--text">
            {{ $t('tanks-set.minimum') }}
          </h3>
          <v-card
            class="ma-0 bg-card-content-minimun"
            height="100"
          >
            <v-card-title class="title-card" />
            <v-card-text>
              <v-col class="content-card">
                <span class="headline-letter">G:</span><span class="headline white-text">{{ tankCurretStatus.targetDeviceTargetTankMinimumGallons }}</span>
              </v-col>
              <v-col class="content-card">
                <span class="headline-letter">L:</span><span class="headline white-text">{{ tankCurretStatus.targetDeviceTargetTankMinimumLiters }}</span>
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
  import filters from '@/common/filters'
  import { repositoryFactory } from '@/api/repositoryFactory'
  const tanksRespository = repositoryFactory.get('tanks')

  export default {
    name: 'TankMiniStateView',
    mixins: [filters],
    props: {
      targetDeviceId: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        tankValue: 0,
        tankCurretStatus: {
          targetDevice: {},
        },
        showErrorMessage: false,
        errorMessage: '',
        polling: null,
        options: {
          text: {
            color: '#000000',
            shadowEnable: true,
            shadowColor: '#000000',
            fontSize: 14,
            fontFamily: 'Helvetica',
            dynamicPosition: false,
            hideText: false,
          },
          progress: {
            color: '#E8E8E8',
            backgroundColor: '#2a7fff',
          },
          layout: {
            height: 35,
            width: 140,
            verticalTextAlign: 61,
            horizontalTextAlign: 43,
            zeroOffset: 0,
            strokeWidth: 30,
            progressPadding: 0,
            type: 'cylinder',
          },
        },
      }
    },
    computed: {
      tankColor () {
        if (this.tankCurretStatus.currentLiters < this.tankCurretStatus.targetDeviceTargetTankMinimumLiters) {
          return 'red'
        } else {
          return '#8BC34A'
        }
      },
    },
    mounted () {
      var self = this
      if (self.targetDeviceId) {
        self.fetchData(self.targetDeviceId)
        self.polling = setInterval(function () { self.fetchData(self.targetDeviceId) }, 1 * 60 * 1000)
      }
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    methods: {
      fetchData (targetDeviceId) {
        var self = this
        tanksRespository.getCurrent(targetDeviceId).then(response => {
          self.tankCurretStatus = response.data.data
          self.tankValue = self.tankCurretStatus.percentage
        }).catch(err => {
          self.showErrorMessage = true
          self.errorMessage = err
        })
      },
    },
  }
</script>
<style>
.v-application .blue--text{
  color: #023A66 !important;
  caret-color: #023A66 !important;
  text-align: center !important;
}
.v-application .current--text{
  background-color: #339999;
  color: #E2AA12 !important;
  caret-color: #E2AA12 !important;
  text-align: center !important;
}
.v-application .minimun--text{
  background-color: #023A66;
  color: #E2AA12 !important;
  caret-color: #E2AA12 !important;
  text-align: center !important;
}
.v-application .headline-letter {
    font-size: 25px !important;
    padding-bottom: 0;
    color: #E2AA12 !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif !important;
}
.icon-color{
  color: #339999 !important;
}
.title-card{
  background-color: white;
}
.content-card{
  font-size: 0rem !important;
    font-weight: normal;
    letter-spacing: 0.009375em !important;
    line-height: 1.75rem;
    font-family: "Roboto", sans-serif !important;
    text-align: center;
    padding: 6px 0 10px 0;
}
.bg-card-content-current{
  background-color: #339999 !important;
}
.bg-card-content-minimun{
  background-color: #023A66 !important;
}
.white-text{
  color: white;
}
</style>
<style lang="sass" scoped>
 .state-title
   height: 45px
</style>
